import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";

import { styles } from "./live-badge.css";

export type LiveBadgeStatus = "live" | "preview" | "paused";

@customElement("live-badge")
export class LiveBadge extends LitElement {
  static override styles = [styles];

  @property({ type: String })
  status: LiveBadgeStatus = "preview";

  @property({ type: String })
  label?: string;

  override render() {
    const badgeClasses = {
      "live-badge": true,
      [this.status]: true,
    };

    const defaultLabels: Record<LiveBadgeStatus, string> = {
      live: "Live",
      preview: "Preview",
      paused: "Paused",
    };

    const displayLabel = this.label ?? defaultLabels[this.status];

    return html`
      <div class=${classMap(badgeClasses)}>
        <div class="live-indicator"></div>
        <span>${displayLabel}</span>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "live-badge": LiveBadge;
  }
}
